<template>
  <Builder
    :blocks="context.blocks"
    :context="{
      cityId: context.cityId,
      club: $route.params.club,
      date: $route.query.date,
      age: $route.params.age,
      zones: $route.query.zones,
      training: $route.query.training,
      trainer: $route.query.trainer,
      minigroup: $route.query.minigroup,
      sections: $route.query.sections,
      paid: $route.query.paid,
    }"
  />
</template>

<script>
import Builder from '~/components/builder/Builder'

export default {
  name: 'TimetableClub',
  components: {
    Builder,
  },
  props: ['context'],
}
</script>
